import BaseLang from '@/locale/lang/zh-TW.js';
var SpeLang = {};
for(var v in BaseLang){
    SpeLang[v] = BaseLang[v];
}
SpeLang.speOrder = {
    mtoNo:'MTO',
    batchNo:'批號',
    X_PerPieceQty:'單件數量',
}
export default SpeLang;